import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const variantesSelo = cva(
  'inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      tom: {
        neutro: 'border-border bg-secondary text-secondary-foreground',
        principal: 'border-transparent bg-primary/10 text-primary',
        sucesso: 'border-transparent bg-success/12 text-success',
        atencao: 'border-transparent bg-amber-500/15 text-amber-700 dark:text-amber-400',
        destaque: 'border-transparent bg-accent text-accent-foreground',
      },
    },
    defaultVariants: { tom: 'neutro' },
  },
);

export interface SeloProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof variantesSelo> {}

export function Badge({ className, tom, ...props }: SeloProps) {
  return <span className={cn(variantesSelo({ tom }), className)} {...props} />;
}

export const Separator = React.forwardRef<
  React.ComponentRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>
>(({ className, orientation = 'horizontal', decorative = true, ...props }, ref) => (
  <SeparatorPrimitive.Root
    ref={ref}
    decorative={decorative}
    orientation={orientation}
    className={cn(
      'shrink-0 bg-border',
      orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
      className,
    )}
    {...props}
  />
));
Separator.displayName = 'Separator';
